import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  bottomSheet: {
    backgroundColor: colors.backgroundL0,
    flex: 1,
  },
  container: {
    borderTopLeftRadius: theme.borderRadius.m,
    borderTopRightRadius: theme.borderRadius.m,
    overflow: 'hidden',
  },
  content: {
    backgroundColor: colors.backgroundL1Alpha,
    borderRadius: theme.borderRadius.s,
    padding: theme.spacing[6],
  },
  contentContainer: {
    paddingHorizontal: theme.spacing[5],
  },
  row: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: theme.spacing[2],
  },
  amount: {
    textAlign: 'right',
  },
  divider: {
    height: 1,
    backgroundColor: colors.borderSubtle,
  },
  description: {
    marginTop: 4,
  },
}));
